import { render, staticRenderFns } from "./ListProjects.vue?vue&type=template&id=a85b3e36&scoped=true"
import script from "./ListProjects.vue?vue&type=script&lang=js"
export * from "./ListProjects.vue?vue&type=script&lang=js"
import style0 from "./ListProjects.vue?vue&type=style&index=0&id=a85b3e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85b3e36",
  null
  
)

export default component.exports